import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { CampanhaSearch, CampanhaSearchTotal } from '../campanha-search';
import { CampanhaSearchView } from '../campanha-search-view';
import { CampanhaFilter } from '../filter';
import { VisualizacaoModo, isVisualizacaoModoPipeline } from '../../../../common/visualizacao-modo';

@Injectable({
    providedIn: 'root'
})
export class CampanhaSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/campanha`;
    }

    /** Realiza a pesquisa do Search View das campanhas */
    searchView(filter: CampanhaFilter, orderByColumn: number, orderByDir: string): Observable<CampanhaSearchView> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderByColumn ? orderByColumn.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        return this.customHttp.get<CampanhaSearchView>(`${this.pathApi}/0/view`, {params});
    }


    /** Realizada a pesquisa as campanhas */
    search(visualizacaoModo: VisualizacaoModo, idsCampanhas: number[], statuses: number[], filter: CampanhaFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<CampanhaSearch[]> {
        // Params
        let params = new HttpParams();

        if (isVisualizacaoModoPipeline(visualizacaoModo.id)) { // Pipeline
            // IDs Campanhas
            if (idsCampanhas && idsCampanhas.length > 0) {
                idsCampanhas.forEach(idCampanha => params = params.append('idCampanha', idCampanha.toString()));
            } else {
                params = params.append('idCampanha', '0'); // Para não trazer nada
            }

            // Statuses
            statuses?.forEach(status => {
                params = params.append('status', status.toString());
            });
        }

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<CampanhaSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa das campanhas */
    getTotais(filter: CampanhaFilter): Observable<CampanhaSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<CampanhaSearchTotal>(`${this.pathApi}/0/total`, {params});
    }

    /** Pesquisa uma única campanha através do ID informado */
    searchOne(idCampanha: number, filter: CampanhaFilter = null, status: number = null): Observable<CampanhaSearch> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Status
        if (status) {
            params = params.append('status', status.toString());
        }

        return this.customHttp.get<CampanhaSearch>(`${this.pathApi}/${idCampanha}/search`, {params});
    }

    /** Pesquisa as campanhas cadastradas para serem utilizadas nos selects */
    searchSelect(filter: CampanhaFilter, orderBy: number, orderByDir: string): Observable<CampanhaSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);

        return this.customHttp.get<CampanhaSearch[]>(`${this.pathApi}/0/select`, {params});
    }
}
